export default __webpack_public_path__ + "static/media/faqs.331eb39d.svg";